import { render, staticRenderFns } from "./DetailRiwayatStok.vue?vue&type=template&id=0e151265&"
import script from "./DetailRiwayatStok.vue?vue&type=script&lang=js&"
export * from "./DetailRiwayatStok.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports